import { Activity } from '../../lib/types/models/ol/activity/activity'
import { Time } from '../../lib/types/utils'

// Default activity created for every LEC OL (see Trello #669). It has no location and no costs,
// so the activities table displays "-" for every column except the name.
export const HOST_FAMILY_DAY_ACTIVITY_NAME = 'Host family day'

export const isHostFamilyDayActivity = (activity: Pick<Activity, 'name'>) =>
  activity.name.trim().toLowerCase() === HOST_FAMILY_DAY_ACTIVITY_NAME.toLowerCase()

// "Host family day" has no schedule: the planner form hides the time inputs and submits this
// fixed 01:00 - 02:00 slot instead, since the backend still requires both times.
export const HOST_FAMILY_DAY_STARTING_TIME: Time = { hours: 1, minutes: 0 }
export const HOST_FAMILY_DAY_ENDING_TIME: Time = { hours: 2, minutes: 0 }
